import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Actions
import { setSelectedAddIdleKm } from 'store/ducks/reports/actions';

// Types
import { ApplicationState } from 'store';

const AddIdleKmFilter: React.FC = () => {
  const dispatch = useDispatch();

  const addIdleKm = useSelector(
    (state: ApplicationState) => state.reports.addIdleKm,
  );

  const handleChange = () => {
    dispatch(setSelectedAddIdleKm({ addIdleKm: !addIdleKm }));
  };

  return (
    <List dense>
      <ListItem button>
        <ListItemText
          id='totalAndIdle'
          primary='Total e Ocioso'
          onClick={handleChange}
        />
        <ListItemSecondaryAction>
          <Radio
            edge='end'
            color='primary'
            onChange={handleChange}
            checked={addIdleKm === true}
            inputProps={{ 'aria-labelledby': 'Total e Ocioso' }}
          />
        </ListItemSecondaryAction>
      </ListItem>
    </List>
  );
};

export default AddIdleKmFilter;
export { AddIdleKmFilter };
